import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Message } from 'primereact/message';
import { useClienteAuth } from '../context/ClienteAuthContext';

const ClientePerfil = () => {
    const { cliente, clienteLogout } = useClienteAuth();
    const [activeTab, setActiveTab] = useState('perfil');

    if (!cliente) {
        return (
            <div className="ec-container" style={{ padding: '4rem 2rem', textAlign: 'center' }}>
                <Message 
                    severity="warn" 
                    text="Inicia sesión para ver tu perfil" 
                    style={{ width: '100%', marginBottom: '2rem' }} 
                />
            </div>
        );
    }

    return (
        <div className="ec-container" style={{ padding: '3rem 0' }}>
            {/* CONTENIDO */}
            <div style={{ display: 'grid', gridTemplateColumns: '280px 1fr', gap: '32px', alignItems: 'start' }}>
                {/* SIDEBAR - AVATAR + MENU */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '32px'
                }}>
                    {/* CARD AVATAR */}
                    <div style={{
                        background: 'linear-gradient(135deg, #0077B6 0%, #00B4D8 100%)',
                        borderRadius: '16px',
                        padding: '28px 20px',
                        color: '#fff',
                        textAlign: 'center',
                        boxShadow: '0 8px 32px rgba(0, 119, 182, 0.15)'
                    }}>
                        {/* Avatar Circle */}
                        <div style={{
                            width: '100px',
                            height: '100px',
                            borderRadius: '50%',
                            background: 'rgba(255, 255, 255, 0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '3rem',
                            marginBottom: '16px',
                            border: '3px solid rgba(255, 255, 255, 0.3)',
                            backdropFilter: 'blur(10px)',
                            margin: '0 auto 16px auto'
                        }}>
                            <i className="pi pi-user"></i>
                        </div>

                        {/* Info */}
                        <h2 style={{
                            fontSize: '1.4rem',
                            fontWeight: '800',
                            margin: '0 0 4px 0',
                            letterSpacing: '-0.5px'
                        }}>
                            {cliente.nombre || cliente.username}
                        </h2>
                        
                        <p style={{
                            fontSize: '0.95rem',
                            opacity: '0.9',
                            margin: '0'
                        }}>
                            @{cliente.username}
                        </p>
                    </div>

                    {/* NAVEGACIÓN */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px'
                    }}>
                        {[
                            { id: 'perfil', label: '👤 Datos Personales', icon: 'pi-user' },
                            { id: 'contacto', label: '📧 Contacto', icon: 'pi-envelope' },
                            { id: 'direccion', label: '📍 Dirección', icon: 'pi-map-marker' },
                            { id: 'seguridad', label: '🔒 Seguridad', icon: 'pi-lock' }
                        ].map(tab => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                style={{
                                    background: activeTab === tab.id ? 'var(--ec-primary)' : 'transparent',
                                    color: activeTab === tab.id ? '#fff' : 'var(--ec-text)',
                                    border: 'none',
                                    padding: '14px 16px',
                                    borderRadius: '12px',
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    fontSize: '1.05rem',
                                    fontWeight: activeTab === tab.id ? '600' : '500',
                                    transition: 'all 0.3s ease',
                                    fontFamily: 'var(--ec-font)'
                                }}
                                onMouseOver={(e) => {
                                    if (activeTab !== tab.id) {
                                        e.target.style.background = 'rgba(0, 119, 182, 0.08)';
                                    }
                                }}
                                onMouseOut={(e) => {
                                    if (activeTab !== tab.id) {
                                        e.target.style.background = 'transparent';
                                    }
                                }}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* CONTENIDO PRINCIPAL */}
                <div>
                    {/* DATOS PERSONALES */}
                    {activeTab === 'perfil' && (
                        <Card style={{
                            borderRadius: '16px',
                            border: '1px solid var(--ec-border)',
                            boxShadow: 'var(--ec-shadow-md)',
                            padding: '28px'
                        }}>
                            <h2 style={{ fontSize: '1.6rem', fontWeight: '700', marginBottom: '20px', color: 'var(--ec-text)' }}>
                                Datos Personales
                            </h2>
                            
                            <div style={{
                                display: 'grid',
                                gap: '20px'
                            }}>
                                {[
                                    { label: 'Nombre Completo', value: cliente.nombre || '-' },
                                    { label: 'Usuario', value: cliente.username },
                                    { label: 'Tipo de Cuenta', value: 'Cliente' }
                                ].map((item, idx) => (
                                    <div key={idx} style={{
                                        display: 'grid',
                                        gridTemplateColumns: '200px 1fr',
                                        gap: '16px',
                                        padding: '16px 0',
                                        borderBottom: idx < 2 ? '1px solid var(--ec-border)' : 'none'
                                    }}>
                                        <div style={{
                                            fontWeight: '600',
                                            color: 'var(--ec-text-secondary)',
                                            fontSize: '0.95rem',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}>
                                            {item.label}
                                        </div>
                                        <div style={{
                                            color: 'var(--ec-text)',
                                            fontSize: '1.1rem',
                                            fontWeight: '500'
                                        }}>
                                            {item.value}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <Divider style={{ margin: '24px 0' }} />

                            <Button 
                                label="✏️ Editar Perfil"
                                className="p-button-rounded"
                                style={{
                                    background: 'linear-gradient(135deg, #0077B6 0%, #00B4D8 100%)',
                                    border: 'none',
                                    padding: '12px 28px',
                                    fontSize: '1.05rem',
                                    fontWeight: '600'
                                }}
                            />
                        </Card>
                    )}

                    {/* CONTACTO */}
                    {activeTab === 'contacto' && (
                        <Card style={{
                            borderRadius: '16px',
                            border: '1px solid var(--ec-border)',
                            boxShadow: 'var(--ec-shadow-md)',
                            padding: '28px'
                        }}>
                            <h2 style={{ fontSize: '1.6rem', fontWeight: '700', marginBottom: '20px' }}>
                                Información de Contacto
                            </h2>
                            
                            <div style={{ display: 'grid', gap: '20px' }}>
                                {[
                                    { icon: 'pi-envelope', label: 'Email', value: cliente.email || 'no@configurado.com' },
                                    { icon: 'pi-phone', label: 'Teléfono', value: cliente.telefono || 'No configurado' }
                                ].map((item, idx) => (
                                    <div key={idx} style={{
                                        display: 'flex',
                                        gap: '16px',
                                        padding: '16px',
                                        background: 'var(--ec-bg)',
                                        borderRadius: '12px',
                                        alignItems: 'center'
                                    }}>
                                        <div style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #0077B6 0%, #00B4D8 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#fff',
                                            fontSize: '1.2rem'
                                        }}>
                                            <i className={`pi ${item.icon}`}></i>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '0.9rem', color: 'var(--ec-text-secondary)', fontWeight: '600' }}>
                                                {item.label}
                                            </div>
                                            <div style={{ fontSize: '1.1rem', fontWeight: '500', color: 'var(--ec-text)' }}>
                                                {item.value}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <Divider style={{ margin: '24px 0' }} />

                            <Button 
                                label="✏️ Actualizar Contacto"
                                className="p-button-rounded"
                                style={{
                                    background: 'linear-gradient(135deg, #0077B6 0%, #00B4D8 100%)',
                                    border: 'none',
                                    padding: '12px 28px',
                                    fontSize: '1.05rem',
                                    fontWeight: '600'
                                }}
                            />
                        </Card>
                    )}

                    {/* DIRECCIÓN */}
                    {activeTab === 'direccion' && (
                        <Card style={{
                            borderRadius: '16px',
                            border: '1px solid var(--ec-border)',
                            boxShadow: 'var(--ec-shadow-md)',
                            padding: '28px'
                        }}>
                            <h2 style={{ fontSize: '1.6rem', fontWeight: '700', marginBottom: '20px' }}>
                                Dirección de Envío
                            </h2>
                            
                            <div style={{
                                padding: '24px',
                                background: 'var(--ec-bg)',
                                borderRadius: '12px',
                                border: '1px dashed var(--ec-border)',
                                textAlign: 'center',
                                marginBottom: '20px'
                            }}>
                                <i className="pi pi-map-marker" style={{ fontSize: '2rem', color: 'var(--ec-text-light)', marginBottom: '12px', display: 'block' }}></i>
                                <p style={{ color: 'var(--ec-text-secondary)', margin: '0' }}>
                                    No hay dirección configurada
                                </p>
                            </div>

                            <Button 
                                label="➕ Agregar Dirección"
                                className="p-button-rounded"
                                style={{
                                    background: 'linear-gradient(135deg, #0077B6 0%, #00B4D8 100%)',
                                    border: 'none',
                                    padding: '12px 28px',
                                    fontSize: '1.05rem',
                                    fontWeight: '600'
                                }}
                            />
                        </Card>
                    )}

                    {/* SEGURIDAD */}
                    {activeTab === 'seguridad' && (
                        <Card style={{
                            borderRadius: '16px',
                            border: '1px solid var(--ec-border)',
                            boxShadow: 'var(--ec-shadow-md)',
                            padding: '28px'
                        }}>
                            <h2 style={{ fontSize: '1.6rem', fontWeight: '700', marginBottom: '20px' }}>
                                Seguridad
                            </h2>
                            
                            <div style={{ display: 'grid', gap: '16px' }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '16px',
                                    background: 'var(--ec-bg)',
                                    borderRadius: '12px'
                                }}>
                                    <div>
                                        <div style={{ fontWeight: '600', color: 'var(--ec-text)' }}>
                                            Contraseña
                                        </div>
                                        <div style={{ fontSize: '0.9rem', color: 'var(--ec-text-secondary)' }}>
                                            Última actualización: Hace 6 meses
                                        </div>
                                    </div>
                                    <Button 
                                        label="Cambiar"
                                        text
                                        style={{ color: 'var(--ec-primary)', fontWeight: '600' }}
                                    />
                                </div>
                            </div>

                            <Divider style={{ margin: '24px 0' }} />

                            <Button 
                                label="🚪 Cerrar Sesión"
                                className="p-button-rounded"
                                onClick={clienteLogout}
                                style={{
                                    background: '#FF1744',
                                    border: 'none',
                                    padding: '12px 28px',
                                    fontSize: '1.05rem',
                                    fontWeight: '600'
                                }}
                            />
                        </Card>
                    )}
                </div>
            </div>

            {/* RESPONSIVE */}
            <style>{`
                @media (max-width: 968px) {
                    .ec-container > div:nth-child(2) {
                        grid-template-columns: 1fr !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default ClientePerfil;
